// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminRolesManagement-commonHeaderAdmin-SMsLB {
	position: fixed !important;
}

.AdminRolesManagement-adminLayout-RLYc2 {
	padding-top: 64px !important;
}

.AdminRolesManagement-box-KSVeu h2 {
	font-size: 21px;
	font-weight: 600;
}

.AdminRolesManagement-exportLink-NW5fI {
	margin-bottom: -29px;
}

.AdminRolesManagement-blockCenter-rjUPl {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.AdminRolesManagement-panelHeader-tXQAr {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.AdminRolesManagement-currencyselect-bZ5DL {
	width: 100%;
	margin-right: 0px;
}

.AdminRolesManagement-panelHeader-tXQAr {
	overflow: hidden;
	position: relative;
}

.AdminRolesManagement-mar0-m5rFq {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.AdminRolesManagement-blockCenter-rjUPl {
		padding: 0px;
	}

	.AdminRolesManagement-panelHeader-tXQAr {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.AdminRolesManagement-sideAdminPageWrapper-miWyN {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.AdminRolesManagement-panelHeader-tXQAr {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.AdminRolesManagement-table-LW7tF {
	display: table;
}

.AdminRolesManagement-tableRow-pxWA_ {
	display: table-row;
}

.AdminRolesManagement-tableCell-QEeHK {
	display: table-cell;
	float: none;
}

.AdminRolesManagement-formGroup-NiK5Q {
	margin-bottom: 6px;
}

.AdminRolesManagement-select-PbUmY {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.AdminRolesManagement-noMargin-fNpfs {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.AdminRolesManagement-exportLink-NW5fI {
	padding-top: 10px;
	padding-right: 10px;
}

.AdminRolesManagement-labelTextNew-dBL2l {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.AdminRolesManagement-displayInline-hcd1t {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.AdminRolesManagement-btnUPdate-QIlJ0 {
	display: inline-block;
}

.AdminRolesManagement-btnModalDelete-aj44n {
	display: inline-block;
	margin-left: 15px;
}

.AdminRolesManagement-radioBtn-w5FLy {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.AdminRolesManagement-backgroundImg-AZ3Ej {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.AdminRolesManagement-btnUPdate-QIlJ0 {
		display: block;
		margin-bottom: 12px;
	}

	.AdminRolesManagement-btnModalDelete-aj44n {
		display: block;
		margin-left: 0px;
	}

	.AdminRolesManagement-btnWidth-HOtm6 {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.AdminRolesManagement-bannerImageBg-IS7E_ {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.AdminRolesManagement-bannerDelete-FhypL {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.AdminRolesManagement-modalRoot-wBNq3 {
	padding: 32px;
}

.AdminRolesManagement-modalBorderBottom-QrpcE {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.AdminRolesManagement-logInModalBody-x24bR {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.AdminRolesManagement-exportSection-TMIKw {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.AdminRolesManagement-exportSectionGridSub-eddaW {
	grid-template-columns: 50% 49% !important;
}

.AdminRolesManagement-exportText-cQMzV {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.AdminRolesManagement-exportLinkImg-_cdOn {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.AdminRolesManagement-vtrMiddle-lnNxQ {
	vertical-align: middle;
}

.AdminRolesManagement-exportImg-FZOiE {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.AdminRolesManagement-profileViewlabel-biu0m {
	display: inline-block;
	width: 38%
}

.AdminRolesManagement-profileViewMainContent-VGChD {
	display: inline-block;
	width: 62%;
}

.AdminRolesManagement-profileViewMain-wTFCj {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.AdminRolesManagement-profileViewInner-zmp1E {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.AdminRolesManagement-profileImageSection-x2Mxl {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.AdminRolesManagement-lastviewInner-gJ7XJ {
	padding: 10px;
}

.AdminRolesManagement-whyHostHoriLine-f86_H {
	margin: 30px 0;
}

.AdminRolesManagement-tableGrid-RcGLx {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.AdminRolesManagement-headingContent-WaEXl {
	font-size: 18px;
	font-weight: 500;
}

.AdminRolesManagement-refundTextColor-FvQi2 {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.AdminRolesManagement-dividerLine-BAh0k {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.AdminRolesManagement-smallContent-HpMPb {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.AdminRolesManagement-sideAdminPageWrapper-miWyN {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.AdminRolesManagement-sideAdminPageWrapper-miWyN {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.AdminRolesManagement-exportSection-TMIKw {
		grid-template-columns: 100%;
	}

	.AdminRolesManagement-exportSectionGridSub-eddaW {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.AdminRolesManagement-profileViewlabel-biu0m {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.AdminRolesManagement-profileViewMainContent-VGChD {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.AdminRolesManagement-ChangeToUpperCase-TQKbK {
	text-transform: uppercase
}

.AdminRolesManagement-noBorder-S1fey {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.AdminRolesManagement-siteAdminHeading-eS4Ql {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.AdminRolesManagement-siteAdminSubHeading-O1gOw {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.AdminRolesManagement-adminFormDivider-Rd3bo {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.AdminRolesManagement-space1-O9TJq {
	margin-bottom: 6px !important;
}

.AdminRolesManagement-space2-P2Qcg {
	margin-bottom: 12px !important;
}

.AdminRolesManagement-space3-eRzeZ {
	margin-bottom: 18px !important;
}

.AdminRolesManagement-space4-ErRNl {
	margin-bottom: 24px !important;
}

.AdminRolesManagement-space5-XWO2D {
	margin-bottom: 30px !important;
}

.AdminRolesManagement-space6-C8CYl {
	margin-bottom: 36px !important;
}

.AdminRolesManagement-space7-Rrk2n {
	margin-bottom: 42px !important;
}

.AdminRolesManagement-spaceTop8-VcFKA {
	margin-bottom: 48px !important;
}

.AdminRolesManagement-spaceTop1-_JfKq {
	margin-top: 6px !important;
}

.AdminRolesManagement-spaceTop2-z9v7y {
	margin-top: 12px !important;
}

.AdminRolesManagement-spaceTop3-MIgBU {
	margin-top: 18px !important;
}

.AdminRolesManagement-spaceTop4-fbfO3 {
	margin-top: 24px !important;
}

.AdminRolesManagement-spaceTop5-rMfhP {
	margin-top: 30px !important;
}

.AdminRolesManagement-spaceTop6-zbQBO {
	margin-top: 36px !important;
}

.AdminRolesManagement-spaceTop7-VCscF {
	margin-top: 42px !important;
}

.AdminRolesManagement-spaceTop8-VcFKA {
	margin-top: 48px !important;
}

.AdminRolesManagement-noMargin-fNpfs {
	margin: 0px !important;
}

.AdminRolesManagement-padding1-TGjR7 {
	padding-bottom: 6px !important;
}

.AdminRolesManagement-padding2-tQ0nK {
	padding-bottom: 12px !important;
}

.AdminRolesManagement-padding3-zLm4j {
	padding-bottom: 18px !important;
}

.AdminRolesManagement-padding4-gDBxm {
	padding-bottom: 24px !important;
}

.AdminRolesManagement-padding5-eVyxU {
	padding-bottom: 30px !important;
}

.AdminRolesManagement-padding6-qc8bG {
	padding-bottom: 36px !important;
}

.AdminRolesManagement-padding7-HqDR4 {
	padding-bottom: 42px !important;
}

.AdminRolesManagement-paddingTop1-udwII {
	padding-top: 6px !important;
}

.AdminRolesManagement-paddingTop2-uJkni {
	padding-top: 12px !important;
}

.AdminRolesManagement-paddingTop3-Xbjwo {
	padding-top: 18px !important;
}

.AdminRolesManagement-paddingTop4-YjfOk {
	padding-top: 24px !important;
}

.AdminRolesManagement-paddingTop5-byXqe {
	padding-top: 30px !important;
}

.AdminRolesManagement-paddingTop6-Nd7b5 {
	padding-top: 36px !important;
}

.AdminRolesManagement-paddingTop7-oDHCY {
	padding-top: 42px !important;
}

.AdminRolesManagement-noPadding-fm1Jf {
	padding: 0px !important;
}

.AdminRolesManagement-textBold-Umx0I {
	font-weight: 500 !important;
}

.AdminRolesManagement-textBolder-ESMvx {
	font-weight: 700 !important;
}

.AdminRolesManagement-textNormal-J1N3e {
	font-weight: normal !important;
}

.AdminRolesManagement-spaceBottom20-zmb6c {
	margin-bottom: 20px;
}

.AdminRolesManagement-spaceBottom10-bX3b5 {
	margin-bottom: 10px;
}

.AdminRolesManagement-marginNone-u7fEN {
	margin: 0;
}

.AdminRolesManagement-spaceBottom15-f0cKt {
	margin-bottom: 15px;
}

.AdminRolesManagement-marginTopNone-wYgRg {
	margin-top: 0;
}

.AdminRolesManagement-spaceTop11-SA5jr {
	margin-top: 11px;
}

.AdminRolesManagement-spaceTop21-ZZf5W {
	margin-top: 21px;
}

.AdminRolesManagement-spaceTop20-NVX_l {
	margin-top: 20px;
}

.AdminRolesManagement-spaceTop10-WlZCX {
	margin-top: 10px;
}

/*New Design Text Colors */

.AdminRolesManagement-textDarkBlue-v8vTl {
	color: rgb(20, 39, 94) !important;
}

.AdminRolesManagement-textLightBlue-euUBt {
	color: rgb(57, 87, 106) !important;
}

.AdminRolesManagement-textLightSandleGreen-IbNk5 {
	color: rgb(76, 86, 41) !important;
}

.AdminRolesManagement-textLightBrown-KLwc0 {
	color: rgb(115, 79, 33) !important;
}

.AdminRolesManagement-textMediumMaroon-c_1Z4 {
	color: rgb(87, 37, 51) !important;
}

.AdminRolesManagement-textBrown-fi_bA {
	color: rgb(160, 47, 24) !important;
}

.AdminRolesManagement-textMaroon-pGHKG {
	color: rgb(155, 49, 67) !important;
}

.AdminRolesManagement-textDarkBrown-vtxys {
	color: rgb(83, 18, 16) !important;
}

.AdminRolesManagement-textMediumBrown-tmfjE {
	color: rgb(142, 28, 10) !important;
}

.AdminRolesManagement-textSkyBlue-FrDcT {
	color: rgb(37, 117, 141) !important;
}

.AdminRolesManagement-textGray-NtjXk {
	color: rgb(77, 65, 51) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/helpers.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `AdminRolesManagement-commonHeaderAdmin-SMsLB`,
	"adminLayout": `AdminRolesManagement-adminLayout-RLYc2`,
	"box": `AdminRolesManagement-box-KSVeu`,
	"exportLink": `AdminRolesManagement-exportLink-NW5fI`,
	"blockCenter": `AdminRolesManagement-blockCenter-rjUPl`,
	"panelHeader": `AdminRolesManagement-panelHeader-tXQAr`,
	"currencyselect": `AdminRolesManagement-currencyselect-bZ5DL`,
	"mar0": `AdminRolesManagement-mar0-m5rFq`,
	"sideAdminPageWrapper": `AdminRolesManagement-sideAdminPageWrapper-miWyN`,
	"table": `AdminRolesManagement-table-LW7tF`,
	"tableRow": `AdminRolesManagement-tableRow-pxWA_`,
	"tableCell": `AdminRolesManagement-tableCell-QEeHK`,
	"formGroup": `AdminRolesManagement-formGroup-NiK5Q`,
	"select": `AdminRolesManagement-select-PbUmY`,
	"noMargin": `AdminRolesManagement-noMargin-fNpfs`,
	"labelTextNew": `AdminRolesManagement-labelTextNew-dBL2l`,
	"displayInline": `AdminRolesManagement-displayInline-hcd1t`,
	"btnUPdate": `AdminRolesManagement-btnUPdate-QIlJ0`,
	"btnModalDelete": `AdminRolesManagement-btnModalDelete-aj44n`,
	"radioBtn": `AdminRolesManagement-radioBtn-w5FLy`,
	"backgroundImg": `AdminRolesManagement-backgroundImg-AZ3Ej`,
	"btnWidth": `AdminRolesManagement-btnWidth-HOtm6`,
	"bannerImageBg": `AdminRolesManagement-bannerImageBg-IS7E_`,
	"bannerDelete": `AdminRolesManagement-bannerDelete-FhypL`,
	"modalRoot": `AdminRolesManagement-modalRoot-wBNq3`,
	"modalBorderBottom": `AdminRolesManagement-modalBorderBottom-QrpcE`,
	"logInModalBody": `AdminRolesManagement-logInModalBody-x24bR`,
	"exportSection": `AdminRolesManagement-exportSection-TMIKw`,
	"exportSectionGridSub": `AdminRolesManagement-exportSectionGridSub-eddaW`,
	"exportText": `AdminRolesManagement-exportText-cQMzV`,
	"exportLinkImg": `AdminRolesManagement-exportLinkImg-_cdOn`,
	"vtrMiddle": `AdminRolesManagement-vtrMiddle-lnNxQ`,
	"exportImg": `AdminRolesManagement-exportImg-FZOiE`,
	"profileViewlabel": `AdminRolesManagement-profileViewlabel-biu0m`,
	"profileViewMainContent": `AdminRolesManagement-profileViewMainContent-VGChD`,
	"profileViewMain": `AdminRolesManagement-profileViewMain-wTFCj`,
	"profileViewInner": `AdminRolesManagement-profileViewInner-zmp1E`,
	"profileImageSection": `AdminRolesManagement-profileImageSection-x2Mxl`,
	"lastviewInner": `AdminRolesManagement-lastviewInner-gJ7XJ`,
	"whyHostHoriLine": `AdminRolesManagement-whyHostHoriLine-f86_H`,
	"tableGrid": `AdminRolesManagement-tableGrid-RcGLx`,
	"headingContent": `AdminRolesManagement-headingContent-WaEXl`,
	"refundTextColor": `AdminRolesManagement-refundTextColor-FvQi2`,
	"dividerLine": `AdminRolesManagement-dividerLine-BAh0k`,
	"smallContent": `AdminRolesManagement-smallContent-HpMPb`,
	"ChangeToUpperCase": `AdminRolesManagement-ChangeToUpperCase-TQKbK`,
	"noBorder": `AdminRolesManagement-noBorder-S1fey`,
	"siteAdminHeading": `AdminRolesManagement-siteAdminHeading-eS4Ql`,
	"siteAdminSubHeading": `AdminRolesManagement-siteAdminSubHeading-O1gOw`,
	"adminFormDivider": `AdminRolesManagement-adminFormDivider-Rd3bo`,
	"space1": `AdminRolesManagement-space1-O9TJq`,
	"space2": `AdminRolesManagement-space2-P2Qcg`,
	"space3": `AdminRolesManagement-space3-eRzeZ`,
	"space4": `AdminRolesManagement-space4-ErRNl`,
	"space5": `AdminRolesManagement-space5-XWO2D`,
	"space6": `AdminRolesManagement-space6-C8CYl`,
	"space7": `AdminRolesManagement-space7-Rrk2n`,
	"spaceTop8": `AdminRolesManagement-spaceTop8-VcFKA`,
	"spaceTop1": `AdminRolesManagement-spaceTop1-_JfKq`,
	"spaceTop2": `AdminRolesManagement-spaceTop2-z9v7y`,
	"spaceTop3": `AdminRolesManagement-spaceTop3-MIgBU`,
	"spaceTop4": `AdminRolesManagement-spaceTop4-fbfO3`,
	"spaceTop5": `AdminRolesManagement-spaceTop5-rMfhP`,
	"spaceTop6": `AdminRolesManagement-spaceTop6-zbQBO`,
	"spaceTop7": `AdminRolesManagement-spaceTop7-VCscF`,
	"padding1": `AdminRolesManagement-padding1-TGjR7`,
	"padding2": `AdminRolesManagement-padding2-tQ0nK`,
	"padding3": `AdminRolesManagement-padding3-zLm4j`,
	"padding4": `AdminRolesManagement-padding4-gDBxm`,
	"padding5": `AdminRolesManagement-padding5-eVyxU`,
	"padding6": `AdminRolesManagement-padding6-qc8bG`,
	"padding7": `AdminRolesManagement-padding7-HqDR4`,
	"paddingTop1": `AdminRolesManagement-paddingTop1-udwII`,
	"paddingTop2": `AdminRolesManagement-paddingTop2-uJkni`,
	"paddingTop3": `AdminRolesManagement-paddingTop3-Xbjwo`,
	"paddingTop4": `AdminRolesManagement-paddingTop4-YjfOk`,
	"paddingTop5": `AdminRolesManagement-paddingTop5-byXqe`,
	"paddingTop6": `AdminRolesManagement-paddingTop6-Nd7b5`,
	"paddingTop7": `AdminRolesManagement-paddingTop7-oDHCY`,
	"noPadding": `AdminRolesManagement-noPadding-fm1Jf`,
	"textBold": `AdminRolesManagement-textBold-Umx0I`,
	"textBolder": `AdminRolesManagement-textBolder-ESMvx`,
	"textNormal": `AdminRolesManagement-textNormal-J1N3e`,
	"spaceBottom20": `AdminRolesManagement-spaceBottom20-zmb6c`,
	"spaceBottom10": `AdminRolesManagement-spaceBottom10-bX3b5`,
	"marginNone": `AdminRolesManagement-marginNone-u7fEN`,
	"spaceBottom15": `AdminRolesManagement-spaceBottom15-f0cKt`,
	"marginTopNone": `AdminRolesManagement-marginTopNone-wYgRg`,
	"spaceTop11": `AdminRolesManagement-spaceTop11-SA5jr`,
	"spaceTop21": `AdminRolesManagement-spaceTop21-ZZf5W`,
	"spaceTop20": `AdminRolesManagement-spaceTop20-NVX_l`,
	"spaceTop10": `AdminRolesManagement-spaceTop10-WlZCX`,
	"textDarkBlue": `AdminRolesManagement-textDarkBlue-v8vTl`,
	"textLightBlue": `AdminRolesManagement-textLightBlue-euUBt`,
	"textLightSandleGreen": `AdminRolesManagement-textLightSandleGreen-IbNk5`,
	"textLightBrown": `AdminRolesManagement-textLightBrown-KLwc0`,
	"textMediumMaroon": `AdminRolesManagement-textMediumMaroon-c_1Z4`,
	"textBrown": `AdminRolesManagement-textBrown-fi_bA`,
	"textMaroon": `AdminRolesManagement-textMaroon-pGHKG`,
	"textDarkBrown": `AdminRolesManagement-textDarkBrown-vtxys`,
	"textMediumBrown": `AdminRolesManagement-textMediumBrown-tmfjE`,
	"textSkyBlue": `AdminRolesManagement-textSkyBlue-FrDcT`,
	"textGray": `AdminRolesManagement-textGray-NtjXk`
};
module.exports = ___CSS_LOADER_EXPORT___;
